import React, { useState, useEffect } from "react";
import Image from "next/image";
import IMAGES from "@/public/assets/img";
import Link from "next/link";
import { useDownloadStrip } from "./downloadStripContext";

const DownloadAppStrip = () => {
  const [open, setOpen] = useState(true);
  const {setDownloadStrip}  = useDownloadStrip();

  const handleClose = () => {
    setOpen(false);
    setDownloadStrip(true)
  };

  if (!open) return null;
  return (
    <>
      <div className="bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-md text-white p-[12px] sm:py-[12px] sm:px-3.5">
        <div className="md:container lg:container md:mx-auto flex justify-between items-center sm:gap-[5px] sm:w-full">
        <div className="flex gap-12 w-full sm:w-auto justify-center sm:gap-[5px] sm:items-center whitespace-nowrap">
          {" "}
          <span className="text-lg text-white font-normal sm:text-xs">
            10X Faster App Get the improved Experience.
          </span>
          <Link
            href="https://play.google.com/store/apps/details?id=com.moglix.credlix"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image
              src={IMAGES.appbanner.googlePlayBtn}
              alt="Google Play"
              height={31}
              width={105}
              quality={100}
              className="sm:w-20 block sm:hidden"
            />
          </Link>
        </div>
        <Link
            href="https://play.google.com/store/apps/details?id=com.moglix.credlix"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image
              src={IMAGES.appbanner.googlePlayBtn}
              alt="Google Play"
              height={31}
              width={105}
              quality={100}
              className="sm:w-20 sm:block hidden"
            />
          </Link>
        <button onClick={handleClose} className="mr-4 sm:mr-0 text-white">
          <svg
              xmlns="https://www.w3.org/2000/svg"
              className="h-4 w-4 sm:h-3 sm:w-3 bg-white text-[#0363C4] rounded-full p-[3px]"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              fill="currentColor"
            >
              <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
            </svg>
        </button>
        </div>
      </div>
    </>
  );
};

export default DownloadAppStrip;
